  import * as types from '../actions/actionTypes';
  import initialTrainingState from './initalTrainingState';
  import Training from '../types/Training';
  import { ActionPayloadType } from '../types/ActionPayloadType'

  export default function trainingReducer( state: Training[] = initialTrainingState.trainings,  action: ActionPayloadType): Training[] {
    switch (action.type) {
      case types.LOAD_TRAININGS_SUCCESS:
        // Load all trainings
        return action.trainingList ?? [];

      case types.ADD_TRAINING_SUCCESS:
        // Add a single training to the list
        if (action.training) {
          return [...state, action.training];
        }
        return state; // Return current state if action.training is undefined

        case types.LOAD_SINGLE_TRAINING_SUCCESS:
          if (action.training) {
            return [
              ...state.filter((training) => training.id !== action.training?.id),
              action.training!, // Assert that action.training is non-null here
            ];
          }
          return state; // Return the current state if action.training is undefined

        case types.SAVE_TRAINING_SUCCESS:
        case types.UPDATE_TRAINING_SUCCESS:
            // Update an existing training
            console.log("existing training:" + JSON.stringify(state));
            if (action.training) {
              const { id } = action.training; // Safely destructure to ensure usage of defined property
              return state.map((training) =>
                training.id === id ? action.training! : training // Use non-null assertion (!)
              );
            }
            return state; // Return current state if action.training is undefined

      case types.DELETE_TRAINING_SUCCESS:
        // Delete a training by id
        if (action.id !== undefined) {
          return state.filter((training) => training.id !== action.id);
        }
        return state; // Return current state if action.id is undefined

      default:
        // Return current state for unknown actions
        return state;
    }
  }
